import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../utils/api';

const PrintWarning = () => {
    const { id } = useParams();
    const [warning, setWarning] = useState(null);

    useEffect(() => {
        const fetchWarning = async () => {
            try {
                const response = await api.get(`/warnings`);
                const allWarnings = response.data;
                const currentWarning = allWarnings.find(w => w.id === parseInt(id));
                setWarning(currentWarning);
            } catch (error) {
                console.error("Error fetching warning:", error);
            }
        };
        fetchWarning();
    }, [id]);

    useEffect(() => {
        if (warning) {
            const timer = setTimeout(() => {
                window.print();
            }, 800);
            return () => clearTimeout(timer);
        }
    }, [warning]);

    if (!warning) return <div className="text-center p-10 font-cairo">جاري تحميل البيانات...</div>;

    const student = warning.student || {};
    const date = new Date(warning.created_at).toLocaleDateString('ar-MA');

    return (
        <div className="print-container">
            <div className="header-section flex justify-between items-start mb-3">
                <div className="text-right leading-tight text-[12px] font-bold">
                    <div>المملكة المغربية</div>
                    <div>جمعية تنمية النقل المدرسي أولاد دحو</div>
                    <div>النقل المدرسي</div>
                </div>
            </div>

            <div className="text-center mb-3">
                <h1 className="text-xl font-bold underline mb-2">إنذار كتابي</h1>
                <div className="flex justify-between items-center text-[12px] font-bold px-2 mb-2">
                    <div>رقم: {warning.id}/{new Date().getFullYear()}</div>
                    <div>التاريخ: {date}</div>
                </div>
            </div>

            <div className="info-section text-[12px] font-bold leading-snug mb-3 pr-2 space-y-0.5">
                <div>إلى السيد(ة): {student.parent_name || '..............................................'}</div>
                <div>ولي أمر التلميذ(ة): {student.full_name || '..............................................'}</div>
                <div>المؤسسة التعليمية: {student.institution?.name || '..............................................'}</div>
                <div>القسم: {student.school_class?.name || '..............................................'}</div>
                <div>المنطقة (الدوار): {student.region?.name || '..............................................'}</div>
            </div>

            <div className="content-section text-[12px] leading-relaxed font-medium mb-3">
                <div className="font-bold mb-1.5">الموضوع: إنذار بسبب مخالفة النظام الداخلي للنقل المدرسي</div>
                
                <div className="mb-1">سلام تام بوجود مولانا الإمام،</div>
                
                <div className="mb-1.5">
                    يشرفنا أن نحيطكم علما بأنه تم تسجيل مخالفة صادرة عن ابنكم/ابنتكم أثناء الاستفادة من خدمة النقل المدرسي، والمتمثلة في:
                </div>

                <div className="bg-slate-50 border border-dashed border-slate-300 p-2 rounded-lg mb-2 text-justify font-bold text-[12px]">
                    {warning.reason}
                </div>

                <div className="mb-1.5 text-justify">
                    وإن هذا السلوك يُعد مخالفاً لمقتضيات النظام الداخلي لجمعية النقل المدرسي، ويؤثر على سلامة وأمن مستعملي الحافلة وعلى حسن سير خدمة النقل.
                </div>

                <div className="mb-1.5 text-justify">
                    لذلك، نوجه إلى ابنكم/ابنتكم هذا الإنذار الكتابي، ونهيب بكم حثه/حثها على الالتزام بقواعد الانضباط واحترام تعليمات السائق والمرافق والمحافظة على ممتلكات الحافلة واحترام باقي التلاميذ.
                </div>

                <div className="mb-1.5 font-bold text-justify">
                    وفي حالة تكرار هذه المخالفة أو ارتكاب أي مخالفة أخرى، ستضطر الجمعية إلى اتخاذ الإجراءات التأديبية المنصوص عليها في النظام الداخلي، والتي قد تصل إلى الحرمان المؤقت أو النهائي من الاستفادة من خدمة النقل المدرسي.
                </div>

                <div className="mb-1">ونرجو منكم التعاون لما فيه مصلحة وسلامة جميع المستفيدين.</div>

                <div className="mb-3">وتفضلوا بقبول فائق عبارات التقدير والاحترام.</div>
            </div>

            <div className="footer-section text-left pl-10 text-[12px] font-bold mb-4">
                <div className="mb-0.5">رئيس جمعية النقل المدرسي</div>
                <div className="mb-2">الاسم: ............................................</div>
                <div>التوقيع والختم: .....................................</div>
            </div>

            {/* Acknowledgment of Receipt Section */}
            <div className="border-t-2 border-slate-800 border-dashed pt-2 mt-auto">
                <h2 className="text-base font-bold text-center mb-2">إشعار بالاستلام</h2>
                
                <div className="text-[12px] font-bold leading-normal pr-2 mb-2 space-y-1">
                    <div>أنا الموقع(ة) أسفله: ................................................................</div>
                    <div>ولي أمر التلميذ(ة): {student.full_name || '................................................................'}</div>
                </div>
                
                <div className="text-center text-[12px] font-bold mb-3">
                    أقر بأنني توصلت بهذا الإنذار واطلعت على مضمونه.
                </div>
                
                <div className="flex justify-between items-start text-[12px] font-bold px-4">
                    <div></div>
                    <div className="text-right">
                        <div className="mb-2">التاريخ: ......./......./.......</div>
                        <div>التوقيع: .......................................</div>
                    </div>
                </div>
            </div>

            <style dangerouslySetInnerHTML={{__html: `
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');
                
                html, body {
                    margin: 0;
                    padding: 0;
                    background: white;
                    height: 100%;
                }

                .print-container {
                    width: 210mm;
                    max-height: 290mm;
                    padding: 8mm 12mm;
                    margin: 0 auto;
                    direction: rtl;
                    font-family: 'Cairo', sans-serif;
                    color: #000;
                    background: #fff;
                    display: flex;
                    flex-direction: column;
                    box-sizing: border-box;
                }

                @media print {
                    @page { 
                        margin: 0; 
                        size: A4 portrait; 
                    }
                    html, body { 
                        background: none; 
                        height: 100%;
                        overflow: hidden;
                    }
                    .print-container { 
                        width: 100%;
                        height: 100vh;
                        max-height: 285mm;
                        padding: 6mm 12mm; 
                        margin: 0;
                        box-shadow: none;
                        page-break-after: avoid;
                        page-break-inside: avoid;
                    }
                    .border-dashed {
                        border-style: dashed !important;
                    }
                }
            `}} />
        </div>
    );
};

export default PrintWarning;
